/**
 * @generated SignedSource<<695ed93d3c386b613b7ad1be26c7167a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateEntityTagInput = {
  name: string;
};
export type AdminAddEntityTagPopoverContentMutation$variables = {
  input: CreateEntityTagInput;
};
export type AdminAddEntityTagPopoverContentMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
      readonly name: string;
      readonly organization: {
        readonly entityTagsCount: {
          readonly totalCount: number;
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"AdminEntityTagsTableRowFragment">;
    } | null;
  };
};
export type AdminAddEntityTagPopoverContentMutation = {
  response: AdminAddEntityTagPopoverContentMutation$data;
  variables: AdminAddEntityTagPopoverContentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v5 = {
  "alias": "entityTagsCount",
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "EntityTagNodeConnection",
  "kind": "LinkedField",
  "name": "entityTags",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": "entityTags(first:1)"
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminAddEntityTagPopoverContentMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateEntityTagResponse",
        "kind": "LinkedField",
        "name": "createEntityTag",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityTag",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AdminEntityTagsTableRowFragment"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminAddEntityTagPopoverContentMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateEntityTagResponse",
        "kind": "LinkedField",
        "name": "createEntityTag",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EntityTag",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EntityTagUsageNodeConnection",
                "kind": "LinkedField",
                "name": "entityTagUsages",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EntityTagUsageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EntityTagUsage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Product",
                            "kind": "LinkedField",
                            "name": "product",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "132013d187f0cd7ed1271e057b8d5651",
    "id": null,
    "metadata": {},
    "name": "AdminAddEntityTagPopoverContentMutation",
    "operationKind": "mutation",
    "text": "mutation AdminAddEntityTagPopoverContentMutation(\n  $input: CreateEntityTagInput!\n) {\n  response: createEntityTag(input: $input) {\n    node {\n      id\n      name\n      ...AdminEntityTagsTableRowFragment\n      organization {\n        entityTagsCount: entityTags(first: 1) {\n          totalCount\n        }\n        id\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment AdminEntityTagsTableRowFragment on EntityTag {\n  id\n  name\n  entityTagUsages {\n    totalCount\n    edges {\n      node {\n        id\n        product {\n          name\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e8ef6695e89040c2d7976497bfb688d8";

export default node;
